/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Button,
  Input,
  Table,
  Select,
  Popconfirm,
  Row,
  Col,
  Tooltip,
} from "antd";
import React, { useState, useRef } from "react";
import {
  DeleteTwoTone,
  CheckOutlined,
  PlusCircleOutlined,
  CheckCircleFilled,
  CloseOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import { Form } from "antd";
import { useSelector } from "react-redux";

import Axios from "../../../api/Axios";

import { getUpdateStatus } from "../ViewUpdateIndex";
import EditableImage from "../../icons/EditIcon";
import { capitalizeWords } from "../../icons/ApplicationColor";
const { Option } = Select;
const ExpandedRowRender2 = ({
  record,
  index,
  // hhh,
  // setHH,
  mainIndex,
  data,
  divisonId,
  CreateFailed,
  CreateSuccessfull,
  manager,
  active,
  modalVisible,
  setModalVisible,
  selectedRecord,
  setSelectedRecord,
  level,
  setLevel,
  // onDelete
}) => {
  console.log(divisonId);

  // console.log(testtt, setTesttt);
  // console.log(testing);

  // console.log(testing1);

  const [stateManage, setStateManage] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [category, setCategory] = useState([]);
  // const [modalVisible, setModalVisible] = useState(false);
  // const [selectedRecord, setSelectedRecord] = useState(null);
  const deleteRecord = (record) => {
    if (record.user_count === 0) {
      onDelete(record);
    } else {
      setSelectedRecord(record);
      setLevel("level3");
      setModalVisible(true);
    }
  };
  const restoreRecord = (record) => {
    onRestore(record);
  };
  //console.log(record.index);
  //console.log(record);
  //console.log(index);
  //console.log(mainIndex);
  //console.log(data);
  const columns = [
    {
      title: "HIERARCY NAME",
      dataIndex: "dep_name_2",
      key: "dep_name_2",
      width: 45, // set width to 150px
      editable: false,
    },
    {
      title: "HIERARCY NAME",
      dataIndex: "dep_name",
      key: "dep_name",
      width: 142, // set width to 150px
      editable: true,
      render: (text) => {
        // Render logic for the manager column
        return (
          <div
            style={{ padding: "8px", paddingLeft: "60px", fontSize: "13px" }}
          >
            {text}
          </div>
        );
      },
    },
    {
      title: "LEVEL",
      dataIndex: "dep_level",
      key: "dep_level",
      width: 145, // set width to 150px
      editable: false,
      render: (text) => {
        // Render logic for the manager column
        return <div style={{ padding: "7px", fontSize: "13px" }}>{text}</div>;
      },
    },
    {
      title: "HIERARCY ID",
      dataIndex: "dep_id",
      key: "dep_id",
      width: 144, // set width to 150px
      editable: true,
      render: (text) => {
        // Render logic for the manager column
        return <div style={{ padding: "7px", fontSize: "13px" }}>{text}</div>;
      },
    },
    {
      title: "STRUCTURES",
      dataIndex: "user_count",
      key: "user_count",
      width: 92, // set width to 150px
      align: "center",
      render: () => {
        // Render logic for the manager column
        return <div>--</div>;
      },
    },
    {
      title: "USERS",
      dataIndex: "user_count",
      key: "user_count",
      width: 79, // set width to 150px
      align: "center",
      render: (text) => {
        // Render logic for the manager column
        return <div style={{ fontSize: "13px" }}>{text}</div>;
      },
    },
    {
      title: "MANAGER",
      dataIndex: "manager",
      key: "manager",
      width: 140, // set width to 150px
      editable: true,
      render: (text, record) => {
        // Render logic for the manager column
        return (
          <div style={{ padding: "7px", fontSize: "13px" }}>
            {record?.manager?.full_name}
          </div>
        );
      },
    },
    {
      title: "ACTION",
      dataIndex: "operation",
      width: 77.5, // set width to 150px
      align: "center",
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <div>
            {active && (
              <CheckCircleFilled
                title="submit"
                style={{
                  color: "#52c41a",
                  fontSize: "1.8rem",
                  fontWeight: "700",
                }}
                onClick={() => onFinish21(record)}
              />
            )}

            <Popconfirm
              title={active ? "Confirm to Deactivate" : "Confirm to Restore"}
              onConfirm={() => {
                active ? deleteRecord(record) : restoreRecord(record);
              }}
            >
              {active ? (
                <>
                  {record?.can_be_deleted ? (
                    <DeleteTwoTone
                      style={{
                        cursor: "pointer",
                        fontSize: "1.8rem",
                        marginLeft: "0.9rem",
                      }}
                      title="delete"
                      twoToneColor="#eb2f96"
                      onClick={() => {
                        // setNewProduct(false);
                        // handleReset();
                      }}
                    />
                  ) : null}
                </>
              ) : (
                <>
                  <SwapOutlined
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8rem",
                      marginLeft: "0.9rem",
                    }}
                    // onClick={() => {
                    //   handleDelete(record);
                    // }}
                    title="Restore"
                  />
                </>
              )}
            </Popconfirm>
            <CloseOutlined
              onClick={() => {
                cancel();
              }}
              style={{
                cursor: "pointer",
                fontSize: "1.8rem",
                marginLeft: "0.9rem",
              }}
            />
          </div>
        ) : record?.update?.edit ? (
          <>
            <Tooltip title={`EDIT - ${record?.dep_level}`}>
              <div style={{ marginLeft: "5px" }}>
                <EditableImage
                  handleRowClick={handleRowClick}
                  recordId={record}
                  disabled={editingKey !== ""}
                />
              </div>
            </Tooltip>
          </>
        ) : null;
      },
    },
  ];
  const cancel = () => {
    setEditingKey("");
  };
  const userInfo = useSelector((state) => state.user);
  const updateAuth = getUpdateStatus(userInfo, 0, 4);
  const onDelete = async (record) => {
    //console.log("In delete in expanded second row")
    const data = {
      status: false,
      division: record.div_level,
      dep_level: record.dep_level,
      updated_by: userInfo?.data?.id,
    };
    try {
      await Axios.put(`/department/${record.id}/`, data, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      cancel();
      CreateSuccessfull("Department level has been Archived");
    } catch (err) {
      //console.log(err);
      CreateFailed(
        err?.response?.data?.detail || "Department level has not been Archived"
      );
    }
  };
  const onRestore = async (record) => {
    const data = {
      status: true,
      division: divisonId,
      dep_level: record.dep_level,
      updated_by: userInfo?.data?.id,
    };
    try {
      await Axios.put(`/department/${record.id}/`, data, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      cancel();
      CreateSuccessfull("Department level has been Archived");
    } catch (err) {
      //console.log(err);
      CreateFailed(
        err?.response?.data?.detail || "Department level has not been Archived"
      );
    }
  };
  const onFinish21 = async (values) => {
    const row = await form.validateFields();
    row.division = divisonId;
    row.dep_level = values.dep_level;
    row.updated_by = userInfo?.data?.id;
    //console.log(values);
    for (const key in row) {
      if (row.hasOwnProperty(key) && row[key] === "none") {
        row[key] = ""; // Replace "none" with an empty string
      }
    }
    try {
      await Axios.put(`/department/${values.id}/`, row, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      cancel();
      CreateSuccessfull("Department level heve been edited");
    } catch (err) {
      //console.log(err);
      CreateFailed(
        err?.response?.data?.detail || "Department level have not been edited"
      );
    }
    //console.log(row);
    //console.log(values);
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const namingData = useSelector((state) => state.orgdeatil);
  //console.log(namingData);
  const formRef = useRef();
  const handleReset = () => {
    formRef.current.resetFields();
  };
  const csrfToken = getCookie("csrftoken");
  const onFinish2 = async (values) => {
    //console.log(values);
    for (const key in values) {
      if (values.hasOwnProperty(key)) {
        // Check if the value is undefined
        if (values[key] === undefined) {
          // Update undefined value to null
          values[key] = null;
        }
      }
    }
    values.division = divisonId;
    values.created_by = userInfo?.data?.id;
    try {
      await Axios.post("/departmentcreate/", values, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);

      handleReset();
      CreateSuccessfull("Department level heve been created");
    } catch (err) {
      //console.log(err);
      CreateFailed(
        err?.response?.data?.detail || "Department level heve not been created"
      );
    }
  };
  const [editingKey, setEditingKey] = useState("");
  const [initialHirearchy, setInitialHirearchy] = useState("");
  const isEditing = (record) => record.id === editingKey;
  const edit = (record) => {
    form.setFieldsValue({
      ...record,
      manager: record?.manager?.id,
    });
    setEditingKey(record.id);
    setInitialHirearchy(record?.dep_id);
  };
  const handleRowClick = (record) => {
    // Navigate to the details page using React Router
    edit(record);
  };
  const [form] = Form.useForm();
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === "manager" ? "select" : "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputNode =
      inputType === "select" ? (
        <Select placeholder="Select Manager" disabled={!active}>
          <Option key={"null"} value={"none"}>
            None
          </Option>
          {manager?.map((app) => (
            <Option key={app.id} value={app.id}>
              {app.full_name}
            </Option>
          ))}
        </Select>
      ) : (
        <Input disabled={!active} />
      );
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
            rules={
              dataIndex === "dep_id"
                ? [
                    {
                      validator: checkUserExists2,
                      validateTrigger: "onChange",
                    },
                  ]
                : dataIndex !== "manager"
                ? [
                    {
                      required: true,
                      message: `Please Input ${title}!`,
                    },
                  ]
                : undefined
            }
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  const [form1] = Form.useForm();
  const [isUserExists2, setIsUserExists2] = useState(false);
  const handleFormChange2 = async (changedValues, allValues) => {
    //console.log(changedValues, allValues);
    if ("dep_id" in changedValues && allValues.dep_id.length > 0) {
      if (allValues.dep_id === initialHirearchy) {
        setIsUserExists2(false);
      } else {
        const response = await Axios.get(
          `/orgstructurecheck/${userInfo.data.organization.id}/?hierarchy=Level1&search=${allValues.dep_id}`
        );
        //console.log(response);
        setIsUserExists2(response.data.exists);
        //console.log(isUserExists2);
      }
    } else {
      setIsUserExists2(false);
    }
  };
  const checkUserExists2 = () => {
    return new Promise(async (resolve, reject) => {
      if (isUserExists2 === undefined) {
        // API call has not completed yet, wait for it to complete and try again
        setTimeout(() => {
          checkUserExists2().then(resolve, reject);
        }, 100);
      } else if (isUserExists2) {
        reject("Client already exists");
      } else {
        resolve();
      }
    });
  };

  const [isUserExists, setIsUserExists] = useState(false);
  const handleFormChange = async (changedValues, allValues) => {
    //console.log(changedValues);
    if ("dep_id" in changedValues && allValues.dep_id.length > 0) {
      const response = await Axios.get(
        `/orgstructurecheck/${userInfo.data.organization.id}/?hierarchy=Level2&search=${allValues.dep_id}`
      );
      //console.log(response);
      setIsUserExists(response.data.exists);
      //console.log(isUserExists);
    }
  };
  const checkUserExists = () => {
    return new Promise(async (resolve, reject) => {
      if (isUserExists === undefined) {
        // API call has not completed yet, wait for it to complete and try again
        setTimeout(() => {
          checkUserExists().then(resolve, reject);
        }, 100);
      } else if (isUserExists) {
        reject("Client already exists");
      } else {
        resolve();
      }
    });
  };

  return (
    <>
      {/* <div style={{ marginTop: "1rem" }}> */}
      <Form
        form={form}
        component={false}
        onValuesChange={handleFormChange2}
        style={{ margin: 0, padding: 0 }}
      >
        <Table
          rowKey="id"
          // bordered
          columns={mergedColumns}
          dataSource={data}
          pagination={false}
          showHeader={false}
          rowClassName="editable-row expanded-row-table-row-2"
          className="secondExpand-table"
          style={{ margin: 0, padding: 0 }}
          components={{
            body: {
              cell: EditableCell,
            },
          }}
        />
      </Form>
      {/* </div> */}
      {/* {secondRowIndex !== record.index && ( */}
      {/* {!hhh[mainIndex][index] && ( */}
      {!stateManage &&
        updateAuth &&
        active &&
        (data.length === 0 || data?.[0]?.update?.add) && (
          <Button
            onClick={
              () =>
                // setsecondRowIndex(record.index)
                // setHH((prevState) => {
                //   const updatedState = [...prevState];
                //   updatedState[mainIndex][index] = true;
                //   return updatedState;
                // })
                setStateManage(true)
              // dispatch(setTableExapneder((prev) => !prev))
            }
            style={{
              background: "white",
              fontWeight: "500",
              fontSize: "1.3rem",
              marginLeft: "15rem",
              marginTop: "1rem",
              marginBottom: "1rem",
            }}
          >
            <PlusCircleOutlined style={{ color: "green" }} />{" "}
            {capitalizeWords(data?.[0]?.dep_level) || "Add"}
          </Button>
        )}
      {/* {secondRowIndex === record.index && ( */}
      {/* {hhh[mainIndex][index] && ( */}
      {stateManage && (
        <div
          style={{
            marginLeft: "7.5rem",
            marginBottom: "2rem",
            width: "100%",
          }}
        >
          <Form
            onFinish={onFinish2}
            ref={formRef}
            form={form1}
            onValuesChange={handleFormChange}
          >
            <Row gutter={10} style={{ marginLeft: "1rem", paddingTop: "2rem" }}>
              <Col xs={24} sm={12} md={10} lg={4} xl={4}>
                <Form.Item
                  name="dep_name"
                  rules={[
                    {
                      required: true,
                      message: "Name is required",
                    },
                  ]}
                >
                  <Input placeholder="Name" name="dep_name" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={10} lg={4} xl={4}>
                <Form.Item name="dep_level" initialValue={namingData.dep_label}>
                  <Input placeholder="level" name="dep_level" disabled />
                </Form.Item>
              </Col>
              <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                <Form.Item
                  name="dep_id"
                  rules={[
                    {
                      validator: checkUserExists,
                      validateTrigger: "onChange",
                    },
                  ]}
                >
                  <Input placeholder="hireracy id" name="dep_id" />
                </Form.Item>
              </Col>
              <Col xs={3} sm={3} md={3} lg={2} xl={2}>
                <Form.Item name="structure">
                  <Input
                    placeholder="structure"
                    name="structure"
                    style={{ display: "none" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={3} xl={3}>
                <Form.Item name="users">
                  <Input
                    placeholder="User"
                    name="users"
                    style={{ display: "none" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                <Form.Item name="manager">
                  <Select placeholder="Manager" name="manager">
                    {manager?.map((app) => (
                      <Option key={app.id} value={app.id}>
                        {app.full_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                <Form.Item>
                  <div>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{
                        background: "transparent",
                        border: "none",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            width: "1.8rem",
                            height: "1.8rem",
                            borderRadius: "50%",
                            backgroundColor: "#52c41a",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <CheckOutlined
                            title="submit"
                            style={{
                              color: "#fff",
                              fontSize: "1.2rem",
                              fontWeight: "700",
                            }}
                          />
                        </div>
                      </div>
                    </Button>
                    <DeleteTwoTone
                      style={{
                        cursor: "pointer",
                        fontSize: "1.7rem",
                        marginLeft: "0.9rem",
                      }}
                      title="delete"
                      twoToneColor="#eb2f96"
                      onClick={() => {
                        // setHH((prevState) => {
                        //   const updatedState = [...prevState];
                        //   updatedState[mainIndex][index] = false;
                        //   return updatedState;
                        // });
                        setStateManage(false);
                      }}
                    />
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          {/* <DeactivationModal
            visible={modalVisible}
            onCancel={handleCancelModal}
            onDeactivate={handleDeactivation}
            record={selectedRecord}
            setRecord={setSelectedRecord}
            name={selectedRecord ? selectedRecord.entity_name : ""}
            level="level3"
          /> */}
        </div>
      )}
    </>
  );
};
export default ExpandedRowRender2;
